<template>
  <div>    
    <div class="notification" :style="{fontWeight: bold ? 'bold' : 'normal'}" @click.stop="goToNotification">
      <div class="notif-heading">
        {{ heading }}
      </div>
      <div class="notif-content">
        {{text | decodeHtml }}
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  props: ["notification"],  
  methods: {
    goToNotification() {
      if(!this.notification) {
        return;
      }
      if(this.$store.getters['notifications/shouldShowNotifications']){
        this.$store.dispatch('notifications/hideNotifications');
      }
      if(this.notification.notificationType === 'board'){
        this.$router.push('/boards/' + this.notification.entityId);
      }
      if(this.notification.notificationType === 'topic'){
        this.$router.push('/topics/' + this.notification.entityId + '?post=unread');
      }
      if(this.notification.notificationType === 'message'){
        const path = this.$route.path;
        this.$router.push('/messages?messageId=' + this.notification.entityId);
        if(path == "/messages"){
            this.$router.go();
        }
      }
      if(this.notification.notificationType === 'mention'){
          this.$router.push(`/topics/${this.notification.secondEntityId}/posts/${this.notification.entityId}`)
      }
    },
  },
  computed: {
    heading() {
      switch (this.notification.notificationType) {
        case "board": return "NEW TOPIC";
        case "topic": return "NEW POST";
        case "message": return "NEW MESSAGE";
        default: return "NEW ACTIVITY";
      }
    },
    text() {
      if(!this.notification){
        return "";
      }
      return this.notification.text;
    },
    bold() {
      if(!this.notification){
        return false;
      }
      return this.notification.isNew;
    }
  }
}
</script>
